import { isSearchTermBulkSearch } from '@helpers/utils';

export const getDeduplicatedSearchTerm = (inputValue: string): string => {
  let currentSearchTerm;

  if (isSearchTermBulkSearch(inputValue)) {
    currentSearchTerm = Array.from(
      new Set([...inputValue.split(',').map(term => term.trim())]),
    ).join(', ');
  } else {
    currentSearchTerm = inputValue;
  }

  return currentSearchTerm;
};
